(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kosale-customer-notes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kosale-customer-notes')) {
    customElements.define(
      'kosale-customer-notes',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;

          this.viewport = this.querySelector('[data-customer-notes-viewport]');
          this.cards = Array.from(this.querySelectorAll('[data-customer-note]'));
          this.previousButton = this.querySelector('[data-customer-notes-previous]');
          this.nextButton = this.querySelector('[data-customer-notes-next]');
          this.updateQueued = false;
          this.layoutUpdateQueued = false;

          if (!this.viewport || this.cards.length === 0) return;

          this.previousButton?.addEventListener('click', () => this.move(-1));
          this.nextButton?.addEventListener('click', () => this.move(1));
          this.viewport.addEventListener('scroll', () => this.queueUpdate(), { passive: true });
          this.resizeObserver = new ResizeObserver(() => this.queueUpdate(true));
          this.resizeObserver.observe(this.viewport);
          this.dataset.ready = 'true';
          this.update(true);
          document.fonts?.ready.then(() => this.queueUpdate(true));
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }

        queueUpdate(updateLayout = false) {
          if (updateLayout) this.layoutUpdateQueued = true;
          if (this.updateQueued) return;
          this.updateQueued = true;
          requestAnimationFrame(() => {
            this.updateQueued = false;
            const shouldUpdateLayout = this.layoutUpdateQueued;
            this.layoutUpdateQueued = false;
            this.update(shouldUpdateLayout);
          });
        }

        getCurrentIndex() {
          const left = this.viewport.scrollLeft;
          const firstCardOffset = this.cards[0]?.offsetLeft || 0;
          let index = 0;
          let distance = Number.POSITIVE_INFINITY;

          this.cards.forEach((card, cardIndex) => {
            const cardDistance = Math.abs(card.offsetLeft - firstCardOffset - left);
            if (cardDistance < distance) {
              index = cardIndex;
              distance = cardDistance;
            }
          });

          return index;
        }

        getVisibleCount() {
          const cardWidth = this.cards[0]?.getBoundingClientRect().width || 1;
          return Math.max(1, Math.round(this.viewport.clientWidth / cardWidth));
        }

        syncDesktopCardWidth() {
          if (window.matchMedia('(min-width: 990px)').matches) {
            this.style.setProperty('--k-notes-card-width', `${this.viewport.clientWidth / 3}px`);
          } else {
            this.style.removeProperty('--k-notes-card-width');
          }
        }

        fitQuotes() {
          const isMobile = window.matchMedia('(max-width: 749px)').matches;
          const isShortViewport = window.matchMedia('(min-width: 750px) and (max-height: 800px)').matches;
          const minimumFontSize = isMobile ? 17 : isShortViewport ? 16 : 18;

          this.cards.forEach((card) => {
            const quote = card.querySelector('blockquote');
            if (!quote) return;

            quote.style.removeProperty('--k-note-font-size');
            const naturalFontSize = Number.parseFloat(getComputedStyle(quote).fontSize);
            const quoteLength = Number.parseInt(card.dataset.quoteLength || quote.textContent.trim().length, 10);
            let scale = 1;

            if (quoteLength > 130) scale = 0.74;
            else if (quoteLength > 105) scale = 0.82;
            else if (quoteLength > 82) scale = 0.89;
            else if (quoteLength > 62) scale = 0.95;

            let targetFontSize = Math.max(minimumFontSize, naturalFontSize * scale);
            quote.style.setProperty('--k-note-font-size', `${targetFontSize}px`);

            const cardBox = card.getBoundingClientRect();
            const quoteBox = quote.getBoundingClientRect();
            const cardPaddingBottom = Number.parseFloat(getComputedStyle(card).paddingBottom) || 0;
            const availableHeight = Math.max(0, cardBox.bottom - cardPaddingBottom - quoteBox.top);

            if (quote.scrollHeight <= availableHeight + 1) return;

            let low = minimumFontSize;
            let high = targetFontSize;
            let fittedFontSize = minimumFontSize;

            for (let iteration = 0; iteration < 7; iteration += 1) {
              const candidate = (low + high) / 2;
              quote.style.setProperty('--k-note-font-size', `${candidate}px`);

              if (quote.scrollHeight <= availableHeight + 1) {
                fittedFontSize = candidate;
                low = candidate;
              } else {
                high = candidate;
              }
            }

            targetFontSize = Math.max(minimumFontSize, fittedFontSize);
            quote.style.setProperty('--k-note-font-size', `${targetFontSize.toFixed(2)}px`);
          });
        }

        move(direction) {
          const maxIndex = Math.max(0, this.cards.length - this.getVisibleCount());
          const nextIndex = Math.min(maxIndex, Math.max(0, this.getCurrentIndex() + direction));
          const firstCardOffset = this.cards[0]?.offsetLeft || 0;
          const targetOffset = this.cards[nextIndex].offsetLeft - firstCardOffset;
          this.viewport.scrollTo({ left: targetOffset, behavior: 'smooth' });
        }

        update(updateLayout = false) {
          if (updateLayout) {
            this.syncDesktopCardWidth();
            this.fitQuotes();
          }
          const maxIndex = Math.max(0, this.cards.length - this.getVisibleCount());
          const currentIndex = Math.min(maxIndex, this.getCurrentIndex());

          if (this.previousButton) this.previousButton.disabled = currentIndex <= 0;
          if (this.nextButton) this.nextButton.disabled = currentIndex >= maxIndex;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
